import{a as o}from"./chunk-VWIO5HEC.js";import{m as e}from"./chunk-HBP5N4FR.js";e();var m=(n,u)=>n.filter(({authenticatedRoute:t})=>Boolean(t)).some(({path:t})=>o(t,u)!==null);export{m as a};
//# sourceMappingURL=chunk-SF7YQV6K.js.map
